/**
 * BE BOLD : Path B: Release and Rebuild
 * Month 4: Foundation Building (Days 91-120)
 *
 * Squeeze at 40-50%, hold 3-5s. Pulsacao introduced.
 *
 * All sessions verified at 300s +/-20s (5 minutes)
 * Generated: 2026-04-13 02:14
 *
 * bebold.au | Paula Tomazetti | 16+ years of study
 * All content is 100% Be Bold.
 */

export const exercises = {

  belly_breath_drop: {
    id: 'belly_breath_drop',
    name: 'Belly Breath Drop',
    name_pt: 'Respiro da Barriga',
    sub: 'The floor drops on the inhale. Stay soft on the exhale.',
    sub_pt: 'O assoalho cai na inspiração. Fique macia na expiração.',
    level: 'Release',
    zone: 'Full floor 0-3cm',
    color: '#7A5A6A',
    movement: 'release',
    inst: `Lie on your back with your knees bent and feet flat. Place one hand on your lower belly.

Inhale slowly through your nose for 4 counts. Feel your belly rise under your hand. Your pelvic floor drops gently as your belly expands. You do not push it. It falls on its own.

Exhale through your mouth for 6 counts. Stay soft. Nothing tightens on the exhale. The floor stays dropped.

If you feel nothing at first, that is your starting point.

Picture it: your pelvic floor is a hammock between two trees. Each inhale, the hammock sinks wider. Each exhale, it stays low.`,
    inst_pt: `Deite de costas com os joelhos dobrados e pés apoiados. Coloque uma mão na barriga baixa.

Inspire lentamente pelo nariz por 4 tempos. Sinta a barriga subir sob sua mão. Seu assoalho pélvico desce suavemente conforme a barriga expande. Você não empurra. Ele cai sozinho.

Expire pela boca por 6 tempos. Fique macia. Nada contrai na expiração. O assoalho continua solto.

Se não sentir nada no início, esse é seu ponto de partida.

Visualize: seu assoalho pélvico é uma rede entre duas árvores. Cada inspiração, a rede afunda e alarga. Cada expiração, ela fica baixa.`,
    breathe: 'Inhale 4 counts to drop. Exhale 6 counts to stay soft.',
    breathe_pt: 'Inspire 4 tempos para soltar. Expire 6 tempos para ficar macia.',
    timerCue: `Inhale.
Drop.
Exhale.
Stay soft.`,
    timerCue_pt: `Inspire.
Solte.
Expire.
Fique macia.`,
    feel: 'A subtle widening and heaviness in the pelvic bowl on every inhale. Nothing tense. Nothing forced.',
    feel_pt: 'Uma sutil abertura e peso na pelve a cada inspiração. Nada tenso. Nada forçado.',
    avoid: 'Do not push the floor down. Do not bear down. Do not tighten on the exhale.',
    avoid_pt: 'Não empurre o assoalho para baixo. Não faça força. Não contraia na expiração.',
    type: 'hold',
    sets: 15,
    hold: 4,
    relax: 6,
    rest: 0,
  },

  child_pose_release: {
    id: 'child_pose_release',
    pose: 'child-pose',
    name: 'Child Pose Release',
    name_pt: 'Soltura na Posição Criança',
    sub: 'The deepest passive stretch for a tight floor.',
    sub_pt: 'O alongamento passivo mais profundo para um assoalho tenso.',
    level: 'Release',
    zone: 'Full floor 0-6cm',
    color: '#7A5A6A',
    movement: 'release',
    inst: `Kneel on a soft surface. Bring your knees wide apart. Sit back onto your heels. Stretch your arms forward on the floor.

Let your forehead rest on the floor or on a pillow. Let your belly hang between your thighs.

Inhale for 4 counts. Feel your belly expand toward the floor. Your pelvic floor lengthens between your sit bones.

Exhale for 6 counts. Let everything drop heavier. Gravity pulls your belly down and your floor opens.

Stay here for the full time. No effort. No movement. Just breathing into the stretch.

Picture it: a cat stretching after a nap. Front paws forward, hips back, belly dropped. Total surrender. Or draping a wet towel over a round surface. The towel has no shape of its own. It just falls over whatever is underneath.`,
    inst_pt: `Ajoelhe numa superfície macia. Abra os joelhos bem. Sente nos calcanhares. Estique os braços para frente no chão.

Deixe a testa descansar no chão ou num travesseiro. Deixe a barriga pendurar entre as coxas.

Inspire por 4 tempos. Sinta a barriga expandir em direção ao chão. Seu assoalho pélvico se alonga entre os ísquios.

Expire por 6 tempos. Deixe tudo cair mais pesado. A gravidade puxa a barriga para baixo e seu assoalho abre.

Fique aqui pelo tempo todo. Sem esforço. Sem movimento. Apenas respirando no alongamento.

Visualize: um gato se espreguiçando depois da soneca. Patas dianteiras para frente, quadril para trás, barriga caída. Rendição total. Ou cobrindo uma superfície arredondada com uma toalha molhada. A toalha não tem forma própria. Apenas cai.`,
    breathe: 'Inhale to lengthen. Exhale to surrender.',
    breathe_pt: 'Inspire para alongar. Expire para se render.',
    timerCue: `Inhale.
Lengthen.
Exhale.
Surrender.`,
    timerCue_pt: `Inspire.
Alongue.
Expire.
Rendição.`,
    feel: 'Deep opening across the entire pelvic floor. The belly hangs. The floor stretches.',
    feel_pt: 'Abertura profunda em todo o assoalho pélvico. A barriga pendura. O assoalho se alonga.',
    avoid: 'Do not bear down. If knees hurt, cushion between calves and thighs.',
    avoid_pt: 'Não faça força. Se joelhos doem, almofada entre panturrilhas e coxas.',
    type: 'timed',
    sets: 1,
    hold: 150,
    rest: 0,
  },

  gentle_push_reset: {
    id: 'gentle_push_reset',
    name: 'Gentle Push Reset',
    name_pt: 'Reset Suave',
    sub: 'After every squeeze set, 3 pushes confirm rest.',
    sub_pt: 'Após cada série de aperto, 3 empurrões confirmam repouso.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8A6A7A',
    movement: 'push',
    inst: `After your squeeze set, exhale and gently push the pelvic floor downward. 15% effort. Hold 4 seconds. Release. Repeat 3 times. This confirms the floor returned to true rest.

Picture it: pressing reset on a stopwatch. Three clicks and you are back to zero.`,
    inst_pt: `Após sua série de aperto, expire e empurre suavemente o assoalho para baixo. 15% esforço. Segure 4 segundos. Solte. Repita 3 vezes. Isso confirma repouso real.

Visualize: apertando reset num cronômetro. Três cliques e volta ao zero.`,
    breathe: 'Exhale to push. Inhale to release.',
    breathe_pt: 'Expire para empurrar. Inspire para soltar.',
    timerCue: `Exhale.
Push.
Release.`,
    timerCue_pt: `Expire.
Empurre.
Solte.`,
    feel: 'Gentle downward opening after each squeeze set.',
    feel_pt: 'Abertura suave para baixo após cada série de aperto.',
    avoid: 'Do not skip after squeeze exercises. Do not strain.',
    avoid_pt: 'Não pule após exercícios de aperto. Não force.',
    type: 'hold',
    sets: 15,
    hold: 4,
    relax: 6,
    rest: 0,
  },

  hip_rock_release: {
    id: 'hip_rock_release',
    name: 'Hip Rock Release',
    name_pt: 'Balanço do Quadril',
    sub: 'Movement teaches the floor to let go.',
    sub_pt: 'Movimento ensina o assoalho a soltar.',
    level: 'Release',
    zone: 'Full floor 0-3cm',
    color: '#7A5A6A',
    movement: 'release',
    inst: `Lie on your back, knees bent, feet flat.

Slowly tilt your pelvis forward: your low back arches slightly away from the floor. Feel your pelvic floor gently stretch open.

Slowly tilt your pelvis back: your low back presses into the floor. Feel your pelvic floor gently compress.

Rock between these two positions slowly. Forward tilt opens the floor. Back tilt closes it lightly. Each rock takes about 4 seconds forward, 4 seconds back.

During the forward tilt, actively breathe into the stretch. Let the floor open.

Picture it: your pelvis is a bowl of water. Tilt forward, water tips toward your belly button. Tilt back, water tips toward your spine. Smooth, no spilling. Or a rocking chair in slow motion, the whole thing moving as one piece.`,
    inst_pt: `Deite de costas, joelhos dobrados, pés apoiados.

Lentamente incline a pelve para frente: a lombar se afasta levemente do chão. Sinta o assoalho pélvico se alongar suavemente.

Lentamente incline a pelve para trás: a lombar pressiona o chão. Sinta o assoalho pélvico comprimir levemente.

Balance entre as duas posições devagar. Inclinação frontal abre o assoalho. Inclinação posterior fecha levemente. Cada balanço leva cerca de 4 segundos para frente, 4 para trás.

Durante a inclinação frontal, respire ativamente no alongamento. Deixe o assoalho abrir.

Visualize: sua pelve é uma tigela de água. Incline para frente, água vai ao umbigo. Incline para trás, água vai à coluna. Suave, sem derramar. Ou cadeira de balanço em câmera lenta, tudo se movendo como uma peça.`,
    breathe: 'Inhale as you tilt forward (open). Exhale as you tilt back (neutral).',
    breathe_pt: 'Inspire ao inclinar para frente (abrir). Expire ao inclinar para trás (neutro).',
    timerCue: `Forward.
Open.
Back.
Neutral.`,
    timerCue_pt: `Frente.
Abra.
Trás.
Neutro.`,
    feel: 'A gentle rocking that alternates between stretching and softening. Like a wave inside your pelvis.',
    feel_pt: 'Um balanço suave que alterna entre alongar e amolecer. Como uma onda dentro da pelve.',
    avoid: 'Do not rush. Do not lift your hips off the ground. Do not bear down.',
    avoid_pt: 'Não apresse. Não levante o quadril do chão. Não faça força.',
    type: 'alt',
    sets: 19,
    hold: 4,
    relax: 4,
    rest: 0,
    altA: 'Forward',
    altA_pt: 'Frente',
    altB: 'Back',
    altB_pt: 'Trás',
  },

  pulsacao: {
    id: 'pulsacao',
    name: 'Pulsação',
    name_pt: 'Pulsação',
    sub: '1 second on, 1 second off. Clean rhythm. Each rep starts fresh.',
    sub_pt: '1 segundo liga, 1 segundo desliga. Ritmo limpo. Cada repetição começa limpa.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8B4A5A',
    movement: 'squeeze',
    inst: `Sit with feet flat. CLOSE and SQUEEZE for 1 second. Release completely for 1 second. That is one rep.

Each contraction is independent. Do not let tension accumulate across reps. The release is 50% of the exercise.

After each set, do 3 Gentle Pushes to confirm full rest.

Picture it: a camera shutter. Click open, click closed. Sharp and complete. No blur between open and closed.`,
    inst_pt: `Sente com pés apoiados. FECHE e APERTE por 1 segundo. Solte completamente por 1 segundo. Isso é uma repetição.

Cada contração é independente. Não deixe tensão acumular. A soltura é 50% do exercício.

Após cada série, faça 3 Empurrões Suaves para confirmar repouso.

Visualize: obturador de câmera. Clique abre, clique fecha. Nítido e completo. Sem borrão.`,
    breathe: 'Exhale to squeeze. Inhale to release.',
    breathe_pt: 'Expire para apertar. Inspire para soltar.',
    timerCue: `Squeeze.
Release.`,
    timerCue_pt: `Aperte.
Solte.`,
    feel: 'Clean on-off rhythm. Release as complete as contraction.',
    feel_pt: 'Ritmo liga-desliga limpo. Soltura tão completa quanto contração.',
    avoid: 'Do not let tension build across reps. Do not bear down.',
    avoid_pt: 'Não deixe tensão acumular entre repetições. Não faça força.',
    type: 'pulse',
    sets: 5,
    rest: 10,
    reps: 12,
    on: 1,
    off: 1,
  },

  squeeze_3s: {
    id: 'squeeze_3s',
    name: 'Foundation Squeeze 3s',
    name_pt: 'Aperto Base 3s',
    sub: 'CLOSE and SQUEEZE at 40%. Hold 3 seconds. Release fully.',
    sub_pt: 'FECHE e APERTE em 40%. Segure 3 segundos. Solte totalmente.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8B4A5A',
    movement: 'squeeze',
    inst: `Lie on your back, knees bent.

CLOSE the pelvic walls inward and SQUEEZE upward at 40% effort. Hold for 3 seconds. Breathe normally while holding.

Release completely for 5 seconds. Full drop. The release matters as much as the lift.

If you cannot feel the squeeze at all, try stopping an imaginary urine stream. That is the muscle group. Once found, never use the stop-urine method as a regular exercise.

Picture it: picking up a grape without crushing it. Hold for 3 seconds. Set it down gently. Or closing a zipper halfway, holding, then unzipping completely.`,
    inst_pt: `Deite de costas, joelhos dobrados.

FECHE as paredes pélvicas para dentro e APERTE para cima com 40% esforço. Segure por 3 segundos. Respire normalmente.

Solte completamente por 5 segundos. Queda total. A soltura importa tanto quanto o aperto.

Se não sentir o aperto, tente parar um jato imaginário de urina. Esse é o grupo muscular. Uma vez encontrado, nunca use o método de parar urina como exercício.

Visualize: pegando uma uva sem esmagar. Segure 3 segundos. Coloque suavemente. Ou fechando zíper até a metade, segurando, depois abrindo completamente.`,
    breathe: 'Exhale to CLOSE and SQUEEZE. Inhale to release.',
    breathe_pt: 'Expire para FECHAR e APERTAR. Inspire para soltar.',
    timerCue: `Squeeze.
Hold 3.
Release.`,
    timerCue_pt: `Aperte.
Segure 3.
Solte.`,
    feel: 'A gentle inward and upward movement. Not in the buttocks. Not in the thighs.',
    feel_pt: 'Um movimento suave para dentro e para cima. Não nos glúteos. Não nas coxas.',
    avoid: 'Do not hold breath. Do not bear down. Do not clench buttocks or inner thighs.',
    avoid_pt: 'Não prenda respiração. Não faça força. Não contraia glúteos ou coxas internas.',
    type: 'hold',
    sets: 19,
    hold: 3,
    relax: 5,
    rest: 0,
  },

  squeeze_5s: {
    id: 'squeeze_5s',
    name: 'Foundation Squeeze 5s',
    name_pt: 'Aperto Base 5s',
    sub: 'CLOSE and SQUEEZE at 50%. Hold 5 seconds.',
    sub_pt: 'FECHE e APERTE em 50%. Segure 5 segundos.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8B4A5A',
    movement: 'squeeze',
    inst: `Lie down or sit. CLOSE and SQUEEZE at 50% effort. Hold 5 seconds. Breathe normally. Release completely for 5 seconds.

The muscle should hold steady for the full 5 seconds. If it fades at 3 seconds, that IS your current limit. Build from there.

Picture it: holding a glass of water steady for 5 seconds, then setting it down. Controlled up and controlled down.`,
    inst_pt: `Deite ou sente. FECHE e APERTE com 50% esforço. Segure 5 segundos. Respire normal. Solte completamente por 5 segundos.

O músculo deve se manter firme por 5 segundos. Se enfraquecer em 3 segundos, esse É seu limite atual. Construa a partir daí.

Visualize: segurando copo d'água firme por 5 segundos, depois colocando. Controlado sobe e controlado desce.`,
    breathe: 'Exhale to engage. Breathe normally while holding.',
    breathe_pt: 'Expire para engajar. Respire normal enquanto segura.',
    timerCue: `Squeeze.
Hold 5.
Release.`,
    timerCue_pt: `Aperte.
Segure 5.
Solte.`,
    feel: 'Definite lift and a steady hold. The lift stays clear from start to finish.',
    feel_pt: 'Elevação e sustentação definida. A elevação permanece clara do início ao fim.',
    avoid: 'Do not hold breath. Do not bear down. Do not compensate.',
    avoid_pt: 'Não prenda respiração. Não faça força. Não compense.',
    type: 'hold',
    sets: 15,
    hold: 5,
    relax: 5,
    rest: 0,
  },
};

export const days = [
  {
    day: 91, week: 13,
    title: 'Day 91', title_pt: 'Dia 91',
    exercises: [
      { ref: 'child_pose_release', overrides: {} }, // 150s
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 92, week: 14,
    title: 'Day 92', title_pt: 'Dia 92',
    exercises: [
      { ref: 'child_pose_release', overrides: {} }, // 150s
      { ref: 'squeeze_5s', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 93, week: 14,
    title: 'Day 93', title_pt: 'Dia 93',
    exercises: [
      { ref: 'hip_rock_release', overrides: {} }, // 152s
      { ref: 'belly_breath_drop', overrides: {} }, // 150s
    ], // Total: 302s = 5.0 min
  },
  {
    day: 94, week: 14,
    title: 'Day 94', title_pt: 'Dia 94',
    exercises: [
      { ref: 'child_pose_release', overrides: {} }, // 150s
      { ref: 'squeeze_3s', overrides: {} }, // 152s
    ], // Total: 302s = 5.0 min
  },
  {
    day: 95, week: 14,
    title: 'Day 95', title_pt: 'Dia 95',
    exercises: [
      { ref: 'squeeze_5s', overrides: {"sets": 10} }, // 100s
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
      { ref: 'child_pose_release', overrides: {"hold": 100} }, // 100s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 96, week: 14,
    title: 'Day 96', title_pt: 'Dia 96',
    exercises: [
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
      { ref: 'squeeze_3s', overrides: {"sets": 12} }, // 96s
      { ref: 'pulsacao', overrides: {"sets": 3} }, // 92s
    ], // Total: 288s = 4.8 min
  },
  {
    day: 97, week: 14,
    title: 'Day 97', title_pt: 'Dia 97',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
      { ref: 'squeeze_5s', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 98, week: 14,
    title: 'Day 98', title_pt: 'Dia 98',
    exercises: [
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
      { ref: 'squeeze_5s', overrides: {"sets": 10} }, // 100s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 99, week: 15,
    title: 'Day 99', title_pt: 'Dia 99',
    exercises: [
      { ref: 'child_pose_release', overrides: {} }, // 150s
      { ref: 'hip_rock_release', overrides: {} }, // 152s
    ], // Total: 302s = 5.0 min
  },
  {
    day: 100, week: 15,
    title: 'Day 100', title_pt: 'Dia 100',
    exercises: [
      { ref: 'belly_breath_drop', overrides: {} }, // 150s
      { ref: 'squeeze_5s', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 101, week: 15,
    title: 'Day 101', title_pt: 'Dia 101',
    exercises: [
      { ref: 'pulsacao', overrides: {"sets": 3} }, // 92s
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
      { ref: 'hip_rock_release', overrides: {"sets": 14} }, // 112s
    ], // Total: 304s = 5.1 min
  },
  {
    day: 102, week: 15,
    title: 'Day 102', title_pt: 'Dia 102',
    exercises: [
      { ref: 'hip_rock_release', overrides: {} }, // 152s
      { ref: 'pulsacao', overrides: {} }, // 160s
    ], // Total: 312s = 5.2 min
  },
  {
    day: 103, week: 15,
    title: 'Day 103', title_pt: 'Dia 103',
    exercises: [
      { ref: 'squeeze_3s', overrides: {} }, // 152s
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
    ], // Total: 302s = 5.0 min
  },
  {
    day: 104, week: 15,
    title: 'Day 104', title_pt: 'Dia 104',
    exercises: [
      { ref: 'squeeze_5s', overrides: {} }, // 150s
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 105, week: 15,
    title: 'Day 105', title_pt: 'Dia 105',
    exercises: [
      { ref: 'pulsacao', overrides: {} }, // 160s
      { ref: 'squeeze_5s', overrides: {"sets": 14} }, // 140s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 106, week: 16,
    title: 'Day 106', title_pt: 'Dia 106',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
      { ref: 'hip_rock_release', overrides: {} }, // 152s
    ], // Total: 302s = 5.0 min
  },
  {
    day: 107, week: 16,
    title: 'Day 107', title_pt: 'Dia 107',
    exercises: [
      { ref: 'belly_breath_drop', overrides: {} }, // 150s
      { ref: 'squeeze_5s', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 108, week: 16,
    title: 'Day 108', title_pt: 'Dia 108',
    exercises: [
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
      { ref: 'child_pose_release', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'squeeze_3s', overrides: {"sets": 12} }, // 96s
    ], // Total: 296.0s = 4.9 min
  },
  {
    day: 109, week: 16,
    title: 'Day 109', title_pt: 'Dia 109',
    exercises: [
      { ref: 'child_pose_release', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'squeeze_5s', overrides: {"sets": 10} }, // 100s
      { ref: 'squeeze_3s', overrides: {"sets": 12} }, // 96s
    ], // Total: 296.0s = 4.9 min
  },
  {
    day: 110, week: 16,
    title: 'Day 110', title_pt: 'Dia 110',
    exercises: [
      { ref: 'squeeze_3s', overrides: {"sets": 12} }, // 96s
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
      { ref: 'child_pose_release', overrides: {"hold": 104} }, // 104s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 111, week: 16,
    title: 'Day 111', title_pt: 'Dia 111',
    exercises: [
      { ref: 'pulsacao', overrides: {"sets": 3} }, // 92s
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
      { ref: 'child_pose_release', overrides: {"hold": 108} }, // 108s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 112, week: 16,
    title: 'Day 112', title_pt: 'Dia 112',
    exercises: [
      { ref: 'child_pose_release', overrides: {} }, // 150s
      { ref: 'belly_breath_drop', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 113, week: 17,
    title: 'Day 113', title_pt: 'Dia 113',
    exercises: [
      { ref: 'hip_rock_release', overrides: {"sets": 12} }, // 96s
      { ref: 'pulsacao', overrides: {"sets": 3} }, // 92s
      { ref: 'squeeze_5s', overrides: {"sets": 11} }, // 110s
    ], // Total: 298s = 5.0 min
  },
  {
    day: 114, week: 17,
    title: 'Day 114', title_pt: 'Dia 114',
    exercises: [
      { ref: 'child_pose_release', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'hip_rock_release', overrides: {"sets": 12} }, // 96s
      { ref: 'squeeze_5s', overrides: {"sets": 10} }, // 100s
    ], // Total: 296.0s = 4.9 min
  },
  {
    day: 115, week: 17,
    title: 'Day 115', title_pt: 'Dia 115',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
      { ref: 'pulsacao', overrides: {} }, // 160s
    ], // Total: 310s = 5.2 min
  },
  {
    day: 116, week: 17,
    title: 'Day 116', title_pt: 'Dia 116',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
      { ref: 'squeeze_3s', overrides: {"sets": 12} }, // 96s
      { ref: 'child_pose_release', overrides: {"hold": 104} }, // 104s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 117, week: 17,
    title: 'Day 117', title_pt: 'Dia 117',
    exercises: [
      { ref: 'pulsacao', overrides: {} }, // 160s
      { ref: 'gentle_push_reset', overrides: {"sets": 14} }, // 140s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 118, week: 17,
    title: 'Day 118', title_pt: 'Dia 118',
    exercises: [
      { ref: 'squeeze_5s', overrides: {} }, // 150s
      { ref: 'hip_rock_release', overrides: {} }, // 152s
    ], // Total: 302s = 5.0 min
  },
  {
    day: 119, week: 17,
    title: 'Day 119', title_pt: 'Dia 119',
    exercises: [
      { ref: 'pulsacao', overrides: {"sets": 3} }, // 92s
      { ref: 'hip_rock_release', overrides: {"sets": 12} }, // 96s
      { ref: 'gentle_push_reset', overrides: {"sets": 11} }, // 110s
    ], // Total: 298s = 5.0 min
  },
  {
    day: 120, week: 18,
    title: 'Day 120', title_pt: 'Dia 120',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
      { ref: 'pulsacao', overrides: {"sets": 3} }, // 92s
      { ref: 'squeeze_5s', overrides: {"sets": 11} }, // 110s
    ], // Total: 302s = 5.0 min
  },
];


export const monthMeta = {
  month: 4,
  program: 'release',
  phase: 'Foundation Building',
  phase_pt: 'Construcao da Base',
  days_range: [91, 120],
  session_target_seconds: 300,
};

export function resolveDay(dayNumber) {
  const dayData = days.find(d => d.day === dayNumber);
  if (!dayData) return null;
  return { ...dayData, exercises: dayData.exercises.map(ex => ({ ...exercises[ex.ref], ...ex.overrides })) };
}